import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import StaticTexts from '../../../assets/i18n/en.json';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class HelperService {
  public emailReg = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
  public priorityAliasMap: { [key: string]: string } = {};
  notificationStatus = new BehaviorSubject(false);

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
  }

  empty(mixedVar: any | boolean | null | undefined) {
    const undef = '';
    let key = '';

    const emptyValues = [undef, null, false, '', undefined, 'undefined'];

    for (let i = 0, len = emptyValues.length; i < len; i++) {
      if (mixedVar === emptyValues[i]) {
        return true;
      }
    }
    if (typeof mixedVar === 'object') {
      // tslint:disable-next-line:forin
      for (key in mixedVar) {
        // TODO: should we check for own properties only?
        // if (mixed_var.hasOwnProperty(key)) {
        return false;
        // }
      }
      return true;
    }
    return false;
  }

  setPREF(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  getPREF(key: string) {
    if (this.empty(localStorage.getItem(key))) {
      return null;
    }
    return localStorage.getItem(key);
  }

  isEmpty(obj: { hasOwnProperty: (arg0: string) => any; }) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  setPREFString(key: string, value: string) {
    window.localStorage.setItem(key, value);
  }

  getPREFString(key: string) {
    return window.localStorage.getItem(key);
  }

  delPREF(key: string) {
    return window.localStorage.removeItem(key);
  }

  delAllPREF() {
    return window.localStorage.clear();
  }

  isDigit(digit: string) {
    const regex = /^[0-9]+$/;
    if (digit !== '') {
      if (digit.match(regex)) {
        return true;
      }
    }
    return false;
  }

  isNumeric(mixedVar: any | number) {
    const whitespace = ' \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000';
    return (typeof mixedVar === 'number' || (whitespace.indexOf(mixedVar.slice(-1)) === -1)) && mixedVar !== '' && !isNaN(mixedVar);
  }

  isDefined(variable: string | null) {
    if (typeof variable === 'boolean') { return true; }
    return (typeof variable !== undefined && variable !== null && variable !== '');
  }

  parseErrorMessage(message: any) {
    let errorMessage = '';
    try {
      errorMessage = (JSON.parse(message)).message;
    } catch (e) {
      if (typeof message === 'object') {
        errorMessage = message.message;
      } else {
        errorMessage = message;
      }
    }
    return errorMessage;
  }

  showSuccessToast(msg: any) {
    this.toastr.success(msg);
  }

  showSuccessToastMessage(msg: any) {
    this.toastr.show(msg, '', { toastClass: "toast-success", positionClass: 'toast-center-center', timeOut: 1000 });
  }

  showErrorToast(msg: any) {
    this.toastr.error(msg);
  }

  showInfoToast(msg: any) {
    this.toastr.info(msg);
  }

  showLoading() {
    this.spinner.show();
  }

  hideLoading() {
    this.spinner.hide();
  }

  getStaticMessage(key: string | number) {
    return StaticTexts[key];
  }

  hasDiffArray(array1: any, array2: any) {
    const newValue = (array1 && array1.length > 0) ? array1 : '';
    const oldValue = (array2 && array2.length > 0) ? array2 : '';
    return JSON.stringify(newValue) !== JSON.stringify(oldValue);
  }

  getUniqArray(arr: any) {
    const arrStr = arr.map((item: any) => JSON.stringify(item));
    return [...new Set(arrStr)].map((item: any) => JSON.parse(item));
  }

}
